/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect, useState} from 'react'
import {KTIcon, toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link, useNavigate} from 'react-router-dom'
import {useLocation} from 'react-router'
import {
  fetchData,
  getEncryptedRoute,
  toasterrormsg,
  toastsuccessmsg,
  useMenuIdPermissions,
} from '../../../reusable'
import Swal from 'sweetalert2'
import {Tr} from '../../../_metronic/i18n/Tr'

const RestaurantDetailsHeader: React.FC = () => {
  let t = Tr()
  const {menuId, menuIdEdit, menuIdDelete} = useMenuIdPermissions()

  var vendorId = ''
  const vendorData = sessionStorage.getItem('vendor')
  const navigate = useNavigate()

  if (vendorData) {
    var vendor = JSON.parse(vendorData)
    vendorId = vendor.vendorId
  } else {
  }
  const location = useLocation()
  const restaurantId = (location.state as any)?.restaurantId || ''
  const [restaurantDetails, setRestaurantDetails] = useState([]) as any
  const [data, setData] = useState('')
  const [selected, setSelected] = useState('') // restaurant Details api call

  const restaurantDetailsApiCall = async () => {
    var param: any = {
      restaurantId: restaurantId,
    }
    var response: any = await fetchData('vendor/public/restaurantDetail', param)

    if (response.status == '200') {
      var restaurantData = response.data

      if (restaurantData[0]['elegant'] == '0' && restaurantData[0]['traditional'] == '0') {
        setSelected('none')
      } else if (restaurantData[0]['elegant'] == '1') {
        setSelected('hotelelegant')
      } else if (restaurantData[0]['traditional'] == '1') {
        setSelected('hoteltraditional')
      }
      setRestaurantDetails(restaurantData)
    } else {
      toasterrormsg(response.message)
    }
  }
  useEffect(() => {
    restaurantDetailsApiCall()
  }, [])

  const confirmdelete = (restaurantId: any) => {
    Swal.fire({
      title: t('Are you sure?'),
      text: t('You Want To Delete'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    }).then(async (result) => {
      if (result.isConfirmed) {
        var param = {
          restaurantId: restaurantId,
        }

        var res = await fetchData('vendor/public/deleteRestaurant', param)

        if (res.status == '200') {
          navigate('../viewrestaurants/')
        } else {
          toasterrormsg(res.message)
        }
      }
    })
  }

  const rejectconfirmation = async (status: any, id: any) => {
    Swal.fire(
      status == '2'
        ? {
            title: t('Are You Sure? You Want to Reject This Restaurant Document.'),
            icon: 'warning',
            showCancelButton: true,
            input: 'text',
            inputLabel: 'Reason',
            inputPlaceholder: t('Enter Reject Reason'),
            inputValidator: (value) => {
              // Validate input here
              if (!value) {
                return t('Reject Reason Required!')
              }
              if (value.length > 150) {
      return t('Reject Reason cannot exceed 150 characters!')
    }
            },
          }
        : {
            title: t('Are You Sure? You Want to Approve This Restaurant Document.'),
            icon: 'warning',
            showCancelButton: true,
          }
    ).then(async (result) => {
      if (result.isConfirmed) {
        const inputValue = result.value
        if (status == '1') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'restaurant',
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                restaurantDetailsApiCall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else if (inputValue !== undefined && inputValue.trim() !== '' && status == '2') {
          var dataObj: any = {
            id: id,
            status: status,
            type: 'restaurant',
          }

          if (status == '2') {
            dataObj.reason = inputValue
          }

          var res = await fetchData('admin/approverejecthotel', dataObj)

          if (res.status === 200) {
            Swal.fire({
              title: t('Status Change Successfully !'),
              icon: 'success',
            }).then((res) => {
              if (res.isConfirmed) {
                restaurantDetailsApiCall()
              }
            })
          } else {
            Swal.fire({
              title: 'Something went Wrong !',
              icon: 'error',
            })
          }
        } else {
          // If input value is not valid, show error message
          Swal.fire({
            title: t('Invalid Input!'),
            text: t('Please enter a valid reason.'),
            icon: 'error',
          })
        }
      }
    })
  }

  const restaurantElegantApiCall = async () => {
    var tmp2 = sessionStorage.getItem('admin')
    // Step 2: Check if the item is not null
    if (tmp2) {
      // Step 3: Parse the JSON string
      var adminData = JSON.parse(tmp2)
      // Step 4: Access the adminId
      var adminId = adminData.adminId
    }
    var param: any = {
      id: restaurantId,
      categoryId: '3',
      isTraditional: data == 'none' ? '0' : 'hoteltraditional' ? '1' : '0',
      isElegant: data == 'none' ? '0' : 'hotelelegant' ? '1' : '0',
      adminId: adminId,
    }

    var response: any = await fetchData('admin/iselegant', param)

    if (response.status == '200') {
      toastsuccessmsg('Saved Successfully')
      restaurantDetailsApiCall()
    } else {
      toasterrormsg('Something Went Wrong')
    }
  }
  return (
    <>
      {restaurantDetails.map((restaurant: any, index: any) => {
        var imageUrl = ''
        var totalImage = ''
        if (restaurant['images'].length != 0) {
          imageUrl = restaurant['images'][0].mediaPath
          totalImage = '+' + (restaurant['images'].length - 1)
        } else {
          imageUrl = toAbsoluteUrl('/media/avatars/300-1.jpg')
          totalImage = ''
        }
        return (
          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {totalImage ? (
                      <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 p-1'>
                        {totalImage}
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {restaurant['en_name']}
                        </div>

                        <button className='btn btn-sm btn-light-success fw-bolder ms-2 fs-8 py-1 px-3'>
                          {restaurant['subcategoryId'][0]
                            ? restaurant['subcategoryId'][0]['en_name']
                            : ''}
                        </button>
                      </div>

                      <div className='d-flex flex-wrap fw-bold fs-6 mb-4 pe-2'>
                        <div className='d-flex align-items-center text-gray-400 me-5 mb-2'>
                          <KTIcon iconName='geolocation' className='fs-4 me-1' />
                          {restaurant['location']}
                        </div>
                      </div>
                    </div>

                    <div className='mt-5'>
                      {restaurant['businessInfostatus'] == 0 && (
                        <>
                          {menuIdEdit ? (
                            <button
                              className='btn btn-success btn-sm me-3'
                              onClick={() => {
                                rejectconfirmation('1', restaurant['restaurantId'])
                              }}
                            >
                              {t('Approve')}
                            </button>
                          ) : (
                            ''
                          )}
                          {menuIdEdit ? (
                            <button
                              className='btn btn-danger btn-sm me-3'
                              onClick={() => {
                                rejectconfirmation('2', restaurant['restaurantId'])
                              }}
                            >
                              {t('Reject')}
                            </button>
                          ) : (
                            ''
                          )}
                        
                        </>
                      )}
                        {menuIdDelete ? (
                            <button
                              className='btn btn-sm me-3'
                              style={{backgroundColor: 'orange', color: 'white'}}
                              onClick={() => confirmdelete(restaurant['restaurantId'])}
                            >
                              {t('Delete')}
                            </button>
                          ) : (
                            ''
                          )}
                    </div>
                  </div>
                </div>
              </div>
              <div className='col-lg-8 my-3'>
                <div className='row'>
                  {/* <!--begin::Label--> */}
                  <label className='fs-4 form-label'>
                    {t('Is Restaurant Elegant Or Traditional?')}
                  </label>
                  {/* <!--end::Label--> */}
                  <div className='col-4 my-2'>
                    <label className='d-flex text-start' data-kt-button='true'>
                      {/* <!--begin::Radio--> */}
                      <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='isrestaurantelegant'
                          value='restaurantelegant'
                          checked={
                            data != ''
                              ? data == 'restaurantelegant'
                              : selected == 'restaurantelegant'
                          }
                          onClick={() => {
                            setData('restaurantelegant')
                          }}
                        />
                      </span>
                      {/* <!--end::Radio--> */}
                      {/* <!--begin::Info--> */}
                      <span className='ms-5'>
                        <span className='fs-4 fw-bold text-gray-800 d-block'>{t('Elegant')}</span>
                      </span>
                      {/* <!--end::Info--> */}
                    </label>
                  </div>
                  <div className='col-4 my-2'>
                    <label className='d-flex text-start' data-kt-button='true'>
                      {/* <!--begin::Radio--> */}
                      <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='isrestaurantelegant'
                          value='restauranttraditional'
                          checked={
                            data != ''
                              ? data == 'restauranttraditional'
                              : selected == 'restauranttraditional'
                          }
                          onClick={() => {
                            setData('restauranttraditional')
                          }}
                        />
                      </span>
                      {/* <!--end::Radio--> */}
                      {/* <!--begin::Info--> */}
                      <span className='ms-5'>
                        <span className='fs-4 fw-bold text-gray-800 d-block'>
                          {t('Traditional')}
                        </span>
                      </span>
                      {/* <!--end::Info--> */}
                    </label>
                  </div>
                  <div className='col-4 my-2'>
                    <label className='d-flex text-start' data-kt-button='true'>
                      {/* <!--begin::Radio--> */}
                      <span className='form-check form-check-custom form-check-solid form-check-sm align-items-start mt-1'>
                        <input
                          className='form-check-input'
                          type='radio'
                          name='isrestaurantelegant'
                          value='0'
                          checked={data != '' ? data == 'none' : selected == 'none'}
                          onClick={(e: any) => {
                            setData('none')
                          }}
                        />
                      </span>
                      {/* <!--end::Radio--> */}
                      {/* <!--begin::Info--> */}
                      <span className='ms-5'>
                        <span className='fs-4 fw-bold text-gray-800 d-block'>{t('None')}</span>
                      </span>
                      {/* <!--end::Info--> */}
                    </label>
                  </div>
                </div>
                {menuIdEdit ? (
                  <button className='btn btn-success' onClick={() => restaurantElegantApiCall()}>
                    {t('Save')}
                  </button>
                ) : (
                  ''
                )}
              </div>
              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/restaurantoverview/' && 'active')
                      }
                      to={getEncryptedRoute('../restaurantoverview/', {menuId: menuId})}
                      state={{restaurantId: restaurantId}}
                    >
                      {t('All Details')}
                    </Link>
                  </li>
                  {/* <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/viewrestaurantcontract/' && 'active')
                      }
                      to={getEncryptedRoute('../viewrestaurantcontract/', {menuId: menuId})}
                      state={{restaurantId: restaurantId, vendorId: restaurantDetails[0]?.vendorId}}
                    >
                      {t('Contract')}
                    </Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
        )
      })}
    </>
  )
}

export {RestaurantDetailsHeader}
